'use client';

import initTranslations from '@/app/(frontend)/i18n';
import { createInstance, Resource } from 'i18next';
import { I18nextProvider } from 'react-i18next';

export default function TranslationsProvider({
    children,
    locale,
    namespaces,
    resources,
}: {
    children: React.ReactNode;
    locale: string;
    namespaces: string[];
    resources?: Resource;
}) {
    const i18n = createInstance();

    initTranslations(locale, namespaces, i18n, resources);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
